module.exports = __webpack_public_path__ + "img/53.59880ba4.png";